"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Control_1 = __importDefault(require("ol/control/Control"));
const utils_1 = require("./utils");
class LayerControl extends Control_1.default {
    constructor(options) {
        const rootElement = options.element;
        if (rootElement === undefined)
            throw new Error("Root element for LayerControl is undefined. Check parameter 'element' in options.");
        super({
            element: options.element,
            target: options.target
        });
        this.selectedBaseMap = options.selectedBaseMap;
        this.updateCtrl = options.updateCtrl(this);
        this.useCountrySelector = options.useCountrySelector ?? false;
        this.countrySelector = undefined;
        const switchBtn = document.createElement('button');
        switchBtn.setAttribute('class', 'ol');
        this.layersDiv = document.createElement('div');
        this.layersDiv.setAttribute('style', 'display: none;');
        switchBtn.addEventListener('mouseenter', _ => {
            switchBtn.setAttribute('style', 'display: none;');
            this.layersDiv.setAttribute('style', 'display: inline;');
        });
        rootElement.addEventListener('mouseout', e => {
            if (e.target !== this.countrySelector && (!rootElement.contains(e.relatedTarget))) {
                switchBtn.setAttribute('style', 'display: inline;');
                this.layersDiv.setAttribute('style', 'display: none;');
            }
        });
        this.element.appendChild(switchBtn);
        this.element.appendChild(this.layersDiv);
    }
    get baseMaps() {
        return this.map === undefined
            ? []
            : (0, utils_1.findLayers)(this.map, (l) => l.get('layerType') === 'baseMap');
    }
    get toggles() {
        return this.map === undefined
            ? []
            : (0, utils_1.findLayers)(this.map, (l) => l.get('layerType') === 'toggle');
    }
    get visibleToggleLayerIds() {
        return this.map === undefined
            ? []
            : (0, utils_1.findLayers)(this.map, (l) => l.get('layerType') === 'toggle' && l.getVisible())
                .map(layer => layer.get('id'));
    }
    toggleBaseMaps(baseMapToActivate) {
        this.selectedBaseMap = baseMapToActivate;
        this.baseMaps.forEach(bm => {
            bm.setVisible(bm.get('id') === baseMapToActivate);
        });
        this.changed();
    }
    toggleLayers(layerId, checked) {
        this.map?.getLayers()
            .getArray()
            .filter(layer => layer.get('layerType') === 'toggle' && layer.get('id') === layerId)
            .forEach(layer => layer.setVisible(checked));
        this.changed();
    }
    setMap(map) {
        super.setMap(map);
        this.map = map;
        this.updateCtrl();
        map.getLayers().on('add', this.updateCtrl);
    }
    addCountrySelectors(stationFilter, countryFilter, updatePersistedProps) {
        const countrySelector = this.countrySelector;
        if (countrySelector === undefined)
            return;
        const option = document.createElement('option');
        option.setAttribute('value', '0');
        option.innerHTML = 'All countries';
        countrySelector.appendChild(option);
        stationFilter.countryList.forEach((country) => {
            const option = document.createElement('option');
            option.setAttribute('value', country.val);
            option.innerHTML = country.name;
            countrySelector.appendChild(option);
        });
        countrySelector.addEventListener('change', e => {
            stationFilter.filterFn(stationFilter, e.target.value);
            if (updatePersistedProps)
                updatePersistedProps({ countryFilter: countrySelector.value });
        });
        if (countryFilter) {
            countrySelector.value = countryFilter;
            countrySelector.dispatchEvent(new Event('change'));
        }
    }
    toggleInput(ctrlType, id, isChecked) {
        const input = document.getElementById(this.createId(ctrlType, id));
        if (input)
            input.checked = isChecked;
    }
    ;
    createId(ctrlType, id) {
        return ctrlType + id;
    }
}
exports.default = LayerControl;
